import React from "react"
import { DomainSettingContainer } from "../../containers"
// import { SiteAPI } from '../../requests';
// import { useAsync } from '../../hooks';
// import { KzFrame } from '../../components';


const DomainSettingPage: React.FC<any> = (props) => {
  const { match } = props;
  // const { result=[] } = useAsync(
  //   () => SiteAPI.getSpecialSiteId()
  // )
  return (
    <>
      <DomainSettingContainer siteId={match.params.siteId}/>
      
      {/* {   //站点白名单
      //@ts-ignore
        result && result.includes(parseInt(match.params.siteId))? (
          <DomainSettingContainer siteId={match.params.siteId}/>
        ):(
          <KzFrame src={`/site/domain?site_id=${match.params.siteId}`}/>
        )
      } */}
    </>
  )
}

export default DomainSettingPage;